import { TmdxAvatar } from '@ds';
import { ChipWithStatus } from '@ui';

type UserAvatarWithPrimaryProps = {
  name: string;
  photo: string;
  isPrimary?: boolean;
};

export const UserAvatarWithPrimary = ({ name, photo, isPrimary = false }: UserAvatarWithPrimaryProps) => {
  return (
    <div className="flex flex-col items-center w-14 relative">
      <TmdxAvatar className="shrink-0" size="lg" radius="lg" name={name} src={photo} />
      {isPrimary && (
        <ChipWithStatus variant="solid" size="xxs" color="success" className="absolute bottom-[-12px]">
          Primary
        </ChipWithStatus>
      )}
    </div>
  );
};
